module.exports = __webpack_public_path__ + "img/MoneyWarning.852d4bd9.svg";